"use client";

import useTranslate from "@app/_hooks/useTranslate";
import { Quantity } from "@components/ngg";
import { MinusIcon, PlusIcon } from "@ngg/icons";

import { cn } from "@/lib/utils";

import { isCheckoutDisabled } from "../Stock/Stock.utils";
import { useCartItemContext } from "./CartItem.context";

const CartItemQuantity = ({ className }: { className?: string }) => {
  const t = useTranslate();
  const { loading, item, updateItem } = useCartItemContext();

  if (!item) return null;

  return (
    <div className={cn("flex items-center gap-x-1 md:gap-x-2", className)}>
      {t("quantity", { strict: true }) && (
        <span className="text-sm uppercase">{t("quantity")}:</span>
      )}
      <Quantity
        dense
        readOnly
        disabled={loading}
        value={item.quantity}
        onIncrease={() =>
          isCheckoutDisabled(item)
            ? null
            : updateItem({
                ...item,
                quantity: item.quantity + 1,
              })
        }
        onDecrease={() =>
          updateItem({
            ...item,
            quantity: item.quantity - 1,
          })
        }
        DecreaseIcon={<MinusIcon />}
        IncreaseIcon={<PlusIcon />}
        classNames={{
          wrapper:
            "border-x-1 border-grey-150 child:border-grey-150 divide-x h-5 max-w-16",
          decreaseButton: "flex justify-center items-center basis-1/3 text-sm",
          increaseButton: cn(
            "flex basis-1/3 items-center justify-center text-sm",
            isCheckoutDisabled(item) && "cursor-not-allowed opacity-50",
          ),
          input: "basis-1/3 text-sm",
        }}
      />
    </div>
  );
};

CartItemQuantity.displayName = "CartItemQuantity";

export default CartItemQuantity;
